// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { TerceraChart } from '@front/chart/TerceraChart';
import { BaseChartRactive } from './BaseChartRactive';
export class TerceraChartRactive extends BaseChartRactive {
    constructor() {
        super();
        this.onIsChartHasMinSizeChange = (value) => {
            this.terceraChart.setIsChartHasMinSize(value);
        };
    }
    oncomplete() {
        super.oncomplete();
        this.observe('isChartHasMinSize', this.onIsChartHasMinSizeChange);
    }
    createChart() {
        return new TerceraChart(this.context, this.get('terceraChartPanelContext'), this.get('id'));
    }
}
BaseChartRactive.extendWith(TerceraChartRactive, {
    data: function () {
        return {
            isChartHasMinSize: true
        };
    }
});
